import React from "react";
import { Grid, Typography, Card, CardContent, CardActionArea, Button } from "@mui/material";
import { FaUserGraduate, FaUsers, FaChalkboardTeacher, FaSchool } from "react-icons/fa";
import "./RoleSelectionForm.css";

const RoleSelection = ({ setRole, setCurrentStep }) => {
  const roles = [
    {
      title: "student",
      icon: <FaUserGraduate />,
      color: "var(--primary-purple)",
    },
    {
      title: "family",
      icon: <FaUsers />,
      color: "var(--dark-purple)",
    },
    {
      title: "teacher",
      icon: <FaChalkboardTeacher />,
      color: "var(--sky-blue)",
    },
    {
      title: "school",
      icon: <FaSchool />,
      color: "var(--mock-purple)",
    },
  ];

  const handleRoleSelection = (selectedRole) => {
    setRole(selectedRole.toLowerCase());
    setCurrentStep("register");
  };

  return (
    <div className="role-selection">
      <Typography variant="h4" component="h2" className="role-selection-title">
        Create an Account for:
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {roles.map((role, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card className="role-card">
              <CardActionArea
                className="role-card-action"
                onClick={() => handleRoleSelection(role.title)}
              >
                <div className="role-icon" style={{ color: role.color }}>
                  {role.icon}
                </div>
                <Typography
                  variant="h6"
                  component="h3"
                  className="role-title"
                  style={{ color: role.color }}
                >
                  {role.title}
                </Typography>
                <CardContent>
                  <Button
                    variant="contained"
                    className="role-button"
                    style={{ backgroundColor: role.color }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent double triggering
                      handleRoleSelection(role.title);
                    }}
                  >
                    Continue
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default RoleSelection;
